module.exports = __webpack_public_path__ + "img/goal.dfe3dc4c.svg";